'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    activateText: 'Refresh immediately after release',
    deactivateText: 'Pull down to refresh',
    finishText: 'Finish refresh'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/lib/pull-to-refresh/locale/en_US.js
// module id = 467
// module chunks = 43